import React from 'react';

import Table from 'components/new_ui/Table';
import { useContext as useMembersContext } from 'components/Managers/Members/Context';
import { useContext as useTeamsContext } from 'components/Managers/Teams/Context';
import { useContext } from 'components/Managers/Programs/Context';
import { columnsTeams } from './columns';

export default function TeamsTable() {
  const { state: stateMembers } = useMembersContext();
  const { state: stateTeams } = useTeamsContext();
  const { dispatch, actions } = useContext();

  const selectMembersFromTeams = (teamIds) => {
    const allMembers = stateMembers.members || [];
    const memberIds = allMembers.filter((member) => teamIds.includes(member.attributes.team_id))
      .map((member) => member.id);

    actions.selectMembers(dispatch, memberIds);
  };

  return (
    <div className="pt-2">
      <Table
        title=" "
        columns={columnsTeams}
        data={stateTeams.teams || []}
        loading={stateTeams.teams === null}
        afterSelect={(selectedRows) => selectMembersFromTeams(selectedRows)}
      />
    </div>
  );
}
